import { combineReducers } from "redux";
import userRoducer from "./action/userReducer";
import mediaPostRoducer from "./action/mediaPostReducer";
import abuseWordReducer from "./action/abuseWordReducer";
import maritalReducer from "./action/maritalReducer";
import castesReducer from "./action/castesReducer";
import religionsReducer from "./action/religionsReducer";
import hobbiesReducer from "./action/hobbiesReducer";
import languagesReducer from "./action/languagesReducer";
import qualificationReducer from "./action/qualificationReducer";
import studyReducer from "./action/studyReducer";
import mediaPostReportReducer from "./action/mediaPostReportReducer";
import userInfoReducer from "./action/userInfoReducer";

const rootReducer = combineReducers({
    getAllUsers: userRoducer,
    getAllMediaPosts: mediaPostRoducer,
    getAllMarital: maritalReducer,
    getAllReligions: religionsReducer,
    getAllCastes: castesReducer,
    getAllHobbies: hobbiesReducer,
    getAllLanguages: languagesReducer,
    getAllQualifications: qualificationReducer,
    getAllStudy: studyReducer,
    getAllAbuseWords: abuseWordReducer,
    getAllMediaPostReport: mediaPostReportReducer,
    getUserProfile: userInfoReducer
});

export default rootReducer;